import { Pill } from '../../../layout/Pill.jsx';
import { formatIQD } from '../../../shared/format.js';

const STATUS = {
  pending: { variant: 'danger', label: 'غير مدفوعة' },
  partial: { variant: 'warning', label: 'دفع جزئي' },
  paid: { variant: 'success', label: 'مدفوعة' }
};

function invTotal(inv) {
  return Number(inv.grandTotal ?? inv.totalAmount ?? 0);
}
function invDue(inv) {
  if (inv.dueAmount != null) return Number(inv.dueAmount);
  return Math.max(0, invTotal(inv) - Number(inv.paidAmount || 0));
}

export function InvoiceSection({ title, icon, invoices = [], emptyHint }) {
  const subtotal = invoices.reduce((s, inv) => s + invTotal(inv), 0);
  const dueSubtotal = invoices.reduce((s, inv) => s + invDue(inv), 0);

  return (
    <div className="rounded-[12px] border border-line overflow-hidden">
      <div className="px-3 py-2 flex items-center justify-between bg-paper-2">
        <div className="font-bold text-[13px] flex items-center gap-1.5">
          {icon ? <span>{icon}</span> : null}
          <span>{title}</span>
        </div>
        <b className="text-orange-deep text-[14px]">{formatIQD(subtotal)}</b>
      </div>
      <div className="bg-white">
        {invoices.length === 0 ? (
          <div className="p-3 text-center text-ink-3 text-[12px]">{emptyHint || 'لا توجد فواتير'}</div>
        ) : (
          <ul className="divide-y divide-line">
            {invoices.map((inv) => {
              const status = STATUS[inv.paymentStatus] || STATUS.pending;
              const due = invDue(inv);
              const itemsCount = Array.isArray(inv.items)
                ? inv.items.reduce((c, it) => c + (Number(it.qty ?? it.quantity) || 1), 0)
                : 0;
              const idTail = String(inv._id || inv.id || '').slice(-5);
              return (
                <li key={inv._id || inv.id} className="px-3 py-2 text-[12px]">
                  <div className="flex items-center justify-between gap-2">
                    <div className="flex items-center gap-2 min-w-0">
                      <span className="font-mono font-bold text-ink-2">{inv.number || `#${idTail || '—'}`}</span>
                      <span className="text-ink-3">•</span>
                      <span className="text-ink-2">{itemsCount} عنصر</span>
                    </div>
                    <Pill variant={status.variant}>{status.label}</Pill>
                  </div>
                  {Array.isArray(inv.items) && inv.items.length > 0 ? (
                    <div className="text-[11px] text-ink-3 mt-1 truncate">
                      {inv.items.slice(0, 3).map((it) => {
                        const name = it.productName || it.name || '';
                        const qty = Number(it.qty ?? it.quantity) || 1;
                        return qty > 1 ? `${name} × ${qty}` : name;
                      }).filter(Boolean).join(' • ')}
                      {inv.items.length > 3 ? ` +${inv.items.length - 3}` : ''}
                    </div>
                  ) : null}
                  <div className="flex items-center justify-between mt-1.5">
                    <span className="text-ink-3 text-[11.5px]">الإجمالي</span>
                    <span className="font-bold">{formatIQD(invTotal(inv))}</span>
                  </div>
                  {due > 0 ? (
                    <div className="flex items-center justify-between">
                      <span className="text-red text-[11.5px]">المتبقي</span>
                      <b className="text-red">{formatIQD(due)}</b>
                    </div>
                  ) : null}
                </li>
              );
            })}
          </ul>
        )}
      </div>
      {invoices.length > 0 && dueSubtotal > 0 ? (
        <div className="px-3 py-1.5 bg-paper-2 flex items-center justify-between text-[11.5px]">
          <span className="text-ink-3">متبقّي القسم</span>
          <b className="text-red">{formatIQD(dueSubtotal)}</b>
        </div>
      ) : null}
    </div>
  );
}
